<template>
  <div class="hero bg-light-1">
    <div class="container">
      <LoadingSpinner v-if="loading" min-height="300px" />
      <Carousel v-if="slides.length > 0 && !error" v-bind="config" class="hero-carousel">
        <Slide v-for="(slide, index) in slides" :key="slide.id || index">
          <div class="slide-container" :style="{ backgroundColor: slide.backgroundColor }">
            <div class="slide-text">
              <h1 v-if="slide.showTitle" :style="{ color: slide.titleColor }">{{ slide.title }}</h1>
              <div v-html="$sanitize.sanitizeCarouselContent(slide.content)"></div>
              <a
                v-if="slide.buttonText"
                :href="slide.linkUrl"
                class="btn btn-orange"
                :style="{
                  backgroundColor: slide.buttonColor,
                  color: slide.buttonTextColor,
                }"
              >
                {{ slide.buttonText }}
              </a>
            </div>
            <div class="slide-image">
              <img :src="slide.desktopImage?.path" :alt="slide.title" />
            </div>
          </div>
        </Slide>
        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script>
  import "vue3-carousel/carousel.css";
  import { Carousel, Slide, Navigation } from "vue3-carousel";
  import { useSlidesStore } from "@/stores/esupplyvet/slidesStore";
  import LoadingSpinner from "@/components/common/LoadingSpinner.vue";

  export default {
    name: "HeroCarousel",
    components: {
      Carousel,
      Slide,
      Navigation,
      LoadingSpinner,
    },
    data() {
      return {
        config: {
          height: "100%",
          itemsToShow: 1,
          gap: 40,
          snapAlign: "center",
          autoplay: 6000,
          autoplayHoverPause: true,
          loop: true,
          wrapAround: true,
          pauseAutoplayOnHover: true,
          breakpointMode: "carousel",
        },
      };
    },
    computed: {
      slidesStore() {
        return useSlidesStore();
      },
      slides() {
        return this.slidesStore.activeSlides;
      },
      loading() {
        return this.slidesStore.isLoading;
      },
      error() {
        return this.slidesStore.error;
      },
    },
    async mounted() {
      await this.slidesStore.initializeSlides();
    },
  };
</script>
